module.exports = __webpack_public_path__ + "img/logo.9d2e876c.png";